import { Link } from "framework7-react";
import { HTMLAttributes } from "react";

type NavLeftPrevProps = Required<Pick<HTMLAttributes<HTMLAnchorElement>, "onClick">>;

export function NavLeftPrev({ onClick }: NavLeftPrevProps) {
  return (
    <Link
      icon="icon-prev"
      onClick={onClick}
    />
  );
}
